export const GET_TAGS    = "GET_TAGS";
export const ADD_TAG     = "ADD_TAG";
export const UPDATE_TAG  = "UPDATE_TAG";
export const DELETE_TAG  = "DELETE_TAG";
